import styled, { css } from 'styled-components'

import { color, space, SpaceProps, spacing, typography } from '../../themes'

export const Item = styled.button<{ active?: boolean }>`
  ${typography('body2')};
  color: ${color('gray.02')};
  background: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${color('red.01')};
  }

  ${({ active }) =>
    active &&
    css`
      color: ${color('red.01')};
      cursor: default;
    `}
`

export type ContainerProps = SpaceProps

export const Container = styled.div<ContainerProps>`
  ${space}
  display: flex;
  gap: ${spacing(2)};

  ${Item} {
    &::after {
      content: '';
      display: block;
      width: 1px;
      height: 18px;
      background: ${color('gray.04')};
      margin-left: ${spacing(2)};
    }

    &:last-child {
      &::after {
        display: none;
      }
    }
  }
`
